export const store: {
  canvas: HTMLCanvasElement | null;
} = {
  canvas: null,
};
